module.exports = __webpack_public_path__ + "static/fonts/iconfont.3b94e56c.woff";